module.exports = __webpack_public_path__ + "static/assets/67c0d0c8fb76b9a31851880183d39d82.svg";